import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Box } from "@mui/material";

import { getParticipantInitials, Participant } from "../lib/activityUtils";
import { formatName } from "../lib/formatName";
import { avatarSize, color, space, theme } from "../theme/designTokens";

type Props = {
  participants: Participant[];
  displayLimit?: number;
};

export const ParticipantsAvatarGroup = ({ participants, displayLimit = 2 }: Props) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: space.xxs }}>
      {participants.slice(0, displayLimit).map((participant, index) => (
        <Avatar
          key={participant.id}
          src={participant.avatarUrl || undefined}
          sx={{
            width: avatarSize.xs,
            height: avatarSize.xs,
            bgcolor: color.background,
            color: color.primary,
            fontSize: theme.typography.fontSize.xxs,
            border: `1px solid ${color.secondary40}`,
            marginLeft: index > 0 ? -space.xs : 0,
            zIndex: participants.length - index,
          }}
          title={formatName(participant)}
        >
          {!participant.avatarUrl &&
            (getParticipantInitials(participant) || <PersonIcon sx={{ fontSize: theme.typography.fontSize.xxs }} />)}
        </Avatar>
      ))}
      {participants.length > displayLimit && (
        <Avatar
          sx={{
            width: avatarSize.xs,
            height: avatarSize.xs,
            bgcolor: color.background,
            color: color.primary,
            border: `1px solid ${color.secondary40}`,
            fontSize: theme.typography.fontSize.xxs,
            marginLeft: -space.xs,
            zIndex: 0,
          }}
        >
          +{participants.length - displayLimit}
        </Avatar>
      )}
    </Box>
  );
};
